import React from 'react';
import { Navbar } from 'react-bootstrap'
import '../Accueil.css'
import ContentBar from './ContentBar'

const Sidebar = ( ) => {
    return (
        <div>
             <Navbar fixed="top" className="col-md-2 d-md-block bg-light nopadding" align="center">
                <Navbar.Brand href="/"><img src="https://clubcapn.com/_files/200000075-b7a3cb89de/logo_bleu.png" alt="logo" width="120"/></Navbar.Brand>
            <ContentBar/>
            </Navbar>
        </div>
    );
};

export default Sidebar;